// extracted by css-extract-rspack-plugin
export default {"pendingActions":"pendingActions-OqfMAL text-xs"};